module.exports = __webpack_public_path__ + "static/media/cifar_temp.8c566b45.png";